import constants from "../../utils/constants";

//Humidity ratio je apsolutna vlaznost

//const elevation = 0;

export const calculateWithHumidities = (
  humidity,
  relativeHumidity,
  elevation
) => {
  const airPressure = Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * elevation * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      ),
    2
    //MidpointRounding.AwayFromZero
  );

  let pd =
    (((humidity / 1000) * (airPressure / 1000)) /
      (relativeHumidity / 100.0) /
      (0.6222 + humidity / 1000)) *
    1000;
  let temperature;

  if (pd < 641) {
    temperature = (271 * Math.log(pd) - 1738.4) / (28.74 - Math.log(pd));
    if (isNaN(temperature)) {
      temperature = 0;
    }
  } else {
    temperature = (234 * Math.log(pd) - 1500.3) / (23.5 - Math.log(pd));
    if (isNaN(temperature)) {
      temperature = 0;
    }
  }

  let enthalpy;
  enthalpy =
    1.01 * temperature + ((2501 + 1.86 * temperature) * humidity) / 1000;
  return { relativeHumidity, temperature, humidity };
};

export const calculateEntalpy = (humidity, enthalpy, elevation) => {
  const airPressure = Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * elevation * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      ),
    2
    //MidpointRounding.AwayFromZero
  );

  let t1 =
    (enthalpy - (2501 * humidity) / 1000) / (1.01 + (1.86 * humidity) / 1000);
  //let t2 = -5.78089371196331;
  let pd = 0;

  let temperature = t1; //> t2 ? t1 : t2;
  return { enthalpy, temperature, humidity };
};

/// <summary>
/// Kalkuliše sve ostale podatke na osnovu
/// temperature i apsolutne vlažnosti vazduha.
/// </summary>
function calculateHumidityRatio(temperature, relativeHumidity, elevation) {
  const airPressure = Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * elevation * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      ),
    2
    //MidpointRounding.AwayFromZero
  );

  let pd =
    temperature < 0
      ? Math.Exp((1738.4 + 28.74 * temperature) / (271 + temperature))
      : Math.Exp((1500.3 + 23.5 * temperature) / (234 + temperature));

  // E121
  let humidityRatio =
    (0.6222 * (relativeHumidity / 100.0) * pd) /
    (airPressure / 1000 - (relativeHumidity / 100) * (pd / 1000));

  let enthalpy =
    1.01 * temperature + ((2501 + 1.86 * temperature) * humidityRatio) / 1000;
  let airDensity =
    (airPressure * (humidityRatio / 1000 + 1)) /
    461.39 /
    (273.15 + temperature) /
    (humidityRatio / 1000 + 0.6222);
}

/// <summary>
/// Kalkuliše sve ostale podatke na osnovu
/// Entalpije i temperature.
/// </summary>
function CalculateHumidities(temperature, enthalpy, elevation) {
  const airPressure = Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * elevation * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      ),
    2
    //MidpointRounding.AwayFromZero
  );

  let pd =
    temperature < 0
      ? Math.Exp((1738.4 + 28.74 * temperature) / (271 + temperature))
      : Math.Exp((1500.3 + 23.5 * temperature) / (234 + temperature));

  let humidityRatio =
    ((enthalpy - 1.01 * temperature) / (2501 + 1.86 * temperature)) * 1000;

  let relativeHumidity = parseInt(
    (((airPressure / 1000 / pd) * 1000) /
      ((0.6222 / humidityRatio) * 1000 + 1)) *
      100
  );

  let airDensity =
    (airPressure * (humidityRatio / 1000 + 1)) /
    461.39 /
    (273.15 + temperature) /
    (humidityRatio / 1000 + 0.6222);
}

//Funkcije iz dokumentacije

//Apsolutna vlaznost vazduha na osnovu relativne vlaznosti i temperature

export function apsolutnaVlaznostVazduha(
  temperature,
  relativeHumidity,
  elevation
) {
  const airPressure = Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * elevation * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      ),
    2
    //MidpointRounding.AwayFromZero
  );
  let humidity =
    (relativeHumidity * airPressure) / (461.5 * (temperature + 273.15) * 100);
  return { relativeHumidity, temperature, humidity };
}

export function entalpijaVazduha(temperature, humidity) {
  let enthalpy = 1.0048 * temperature + humidity * (2501 + 1.86 * temperature);
  return { enthalpy, temperature, humidity };

  /*enthalpy = 1.006 * temperature + humidity * (2501 + 1.86 * temperature)
Where: h is the enthalpy (kJ/kg dry air) t is the dry bulb temperature (°C) w is the humidity ratio or absolute humidity (g/kg)
In this formula, the first term (1.006 * t) represents the sensible heat component, and the second term (w * (2501 + 1.86 * t)) represents the latent heat component.
*/
}

export const dryBulbWetBulb = (dryBulb, wetBulb, altitude) => {
  /*Tdb = Twb / (0.1515 - 0.0061 * RH) + 0.132 * Twb - 0.686
AH = 0.62198 * (e / (P - e)) * 622
Where:
•	Tdb is the dry bulb temperature in °C
•	Twb is the wet bulb temperature in °C
•	RH is the relative humidity as a decimal (e.g., 60% RH = 0.6)
•	e is the vapor pressure in kPa
•	P is the atmospheric pressure in kPa (standard pressure at sea level is approximately 101.325 kPa)
*/
  const temperature = 0;
  const humidity = 0;

  return { temperature, humidity };
};

export const dryBulbDewPoint = (dryBulb, dewPoint, altitude) => {
  const temperature = dryBulb;

  // Calculation for absolute humidity (AH)
  const Tdp = dewPoint;
  const Pws = 6.1078 * Math.pow(10, (7.5 * Tdp) / (237.3 + Tdp));
  const P =
    101.325 * Math.pow(1 - 2.25577 * Math.pow(10, -5) * altitude, 5.25588);
  const RH = Pws / P;
  const AH = (0.62198 * RH * Pws) / (P - RH * Pws);

  return { temperature, humidity: AH };
};

export function dryBulbAbsoluteHumidity(dryBulb, humidityRatio, altitude) {
  /* temperature = (humidityRatio / (0.62198 * (1 + humidityRatio))) / (2.16679 - 0.000555 * AhumidityRatioH) + 0.555
Where:
•	Tdb is the dry bulb temperature in °C
•	AH is the absolute humidity in g/kg
*/

  return { temperature: dryBulb, humidity: humidityRatio };
}

export function dryBulbEnthalpy(dryBulb, enthalpy, altitude) {
  /*humidity = (h - 1.006 * t) / (2501 + 1.86 * t)
Where:
•	h is the enthalpy in kJ/kg dry air
•	t is the dry bulb temperature in °C
 */
  const temperature = 0;
  const humidity = 0;
  return { temperature, humidity };
}

export function wetBulbDewPoint(wetBulb, dewPoint, altitude) {
  const Twb = wetBulb;
  const Tdp = dewPoint;
  const PwsWb = 6.1078 * Math.pow(10, (7.5 * Twb) / (237.3 + Twb));
  const PwsDp = 6.1078 * Math.pow(10, (7.5 * Tdp) / (237.3 + Tdp));
  const P =
    101.325 * Math.pow(1 - 2.25577 * Math.pow(10, -5) * altitude, 5.25588);
  const RH = PwsWb / PwsDp;
  const Tdb = (Twb - 0.151977 * (Twb - Tdp)) / (0.862072 + 0.067533 * RH);

  // Calculation for absolute humidity (AH)
  const Pws = 6.1078 * Math.pow(10, (7.5 * Tdb) / (237.3 + Tdb));
  const AH = (0.62198 * RH * Pws) / (P - RH * Pws);

  return { temperature: Tdb, humidity: AH };
}

export function wetBulbRelativeHumidity(wetBulb, relativeHumidity, altitude) {
  const temperature =
    wetBulb - (0.1515 - 0.0061 * relativeHumidity) * (wetBulb - 14.55);
  /*AH = 0.62198 * (e / (P - e)) * 622
Where:
•	Tdb is the dry bulb temperature in °C
•	Twb is the wet bulb temperature in °C
•	RH is the relative humidity as a decimal (e.g., 60% RH = 0.6)
•	e is the vapor pressure in kPa
•	P is the atmospheric pressure in kPa*/
  // const temperature = 0;
  const humidity = 0;
  return { temperature, humidity };
}
export function wetBulbAbsoluteHumidity(wetBulb, humidityRatio, altitude) {
  const temperature =
    wetBulb -
    (humidityRatio * (2501 + 1.86 * wetBulb)) / (1.006 + 1.86 * wetBulb);
  /*Where:
•	Tdb is the dry bulb temperature in °C
•	Twb is the wet bulb temperature in °C
•	AH is the absolute humidity in g/kg
*/
  return { temperature, humidity: humidityRatio };
}
export function wetBulbEnthalpy(wetBulb, enthalpy, altitude) {
  const humidity = (enthalpy - 1.006 * wetBulb) / (2501 + 1.86 * wetBulb);
  const temperature =
    wetBulb -
    (enthalpy - humidity * (2501 + 1.86 * wetBulb)) / (1.006 + 1.86 * wetBulb);
  /*Where:
•	h is the enthalpy in kJ/kg dry air
•	Twb is the wet bulb temperature in °C*/

  return { temperature, humidity };
}
export function dewPointRelativeHumidity(dewPoint, relativeHumidity, altitude) {
  const airPressure = Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * altitude * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      ),
    2
    //MidpointRounding.AwayFromZero
  );
  const temperature =
    (237.7 * (dewPoint + (17.27 * dewPoint) / (237.7 + dewPoint)) -
      Math.log(relativeHumidity / 100)) /
    (17.27 - (17.27 * dewPoint) / (237.7 + dewPoint));
  // humidity = 0.62198 * (e / (airPressure - e)) * 622;
  /*Where:
•	Tdb is the dry bulb temperature in °C
•	Tdp is the dew point temperature in °C
•	RH is the relative humidity as a decimal (e.g., 60% RH = 0.6)
•	e is the vapor pressure in kPa
•	P is the atmospheric pressure in kPa
 */

  const humidity = 0;
  return { temperature, humidity };
}
export function dewPointAbsoluteHumidity(dewPoint, humidityRatio, altitude) {
  const temperature =
    (dewPoint * (2501 + 1.86 * dewPoint) + 2501 * humidityRatio) /
    (1.006 + 1.86 * dewPoint);
  /*Where:
•	Tdb is the dry bulb temperature in °C
•	Tdp is the dew point temperature in °C
•	AH is the absolute humidity in g/kg
*/
  return { temperature, humidity: humidityRatio };
}
export function dewPointEnthalpy(dewPoint, enthalpy, altitude) {
  const humidity = (enthalpy - 1.006 * dewPoint) / (2501 + 1.86 * dewPoint);
  const temperature =
    dewPoint +
    (enthalpy - humidity * (2501 + 1.86 * dewPoint)) /
      (1.006 + 1.86 * dewPoint);

  return { temperature, humidity };
}
export function relativeHumidityAbsoluteHumidity(
  relativeHumidity,
  humidityRatio,
  altitude
) {
  const temperature = 0;
  const humidity = 0;
  return { temperature, humidity };
}
export function relativeHumidityEnthalpy(relativeHumidity, enthalpy, altitude) {
  /* AH = (h - 1.006 * Tdp) / (2501 + 1.86 * Tdp)
 Where:
•	h is the enthalpy in kJ/kg dry air
•	Tdp is the dew point temperature in °C
*/
  const temperature = 0;
  const humidity = 0;
  return { temperature, humidity };
}
export function absoluteHumidityEnthalpy(humidityRatio, enthalpy, altitude) {
  /*.	If the chosen pair is "Enthalpy" and "Abs. humidity," you can calculate the dry bulb temperature (Tdb) using the following formula:*/
  const temperature =
    (enthalpy - humidityRatio * 2501) / (1.006 + humidityRatio * 1.86);
  /*Where:
•	h is the enthalpy in kJ/kg dry air
•	w is the humidity ratio or absolute humidity in g/kg
•	Tdb is the dry bulb temperature in °C
*/
  return { temperature, humidity: humidityRatio };
}

export const dryBulbRelativeHumidity = (
  dryBulb,
  relativeHumidity,
  altitude
) => {
  const airPressure = Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * altitude * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      ),
    2
    //MidpointRounding.AwayFromZero
  );
  let ppsat = 0;

  if (dryBulb < -40) ppsat = 0.001749;
  else if (dryBulb >= -40 && dryBulb < -30) ppsat = 0.003442;
  else if (dryBulb >= -30 && dryBulb < -20) ppsat = 0.006184;
  else if (dryBulb >= -20 && dryBulb < -10) ppsat = 0.00619;
  else if (dryBulb >= -10 && dryBulb < 0) ppsat = 0.010827;
  else if (dryBulb >= 0 && dryBulb < 10) ppsat = 0.018499;
  else if (dryBulb >= 10 && dryBulb < 20) ppsat = 0.03089;
  else if (dryBulb >= 20 && dryBulb < 30) ppsat = 0.050485;
  else if (dryBulb >= 30 && dryBulb < 40) ppsat = 0.080858;
  else if (dryBulb >= 40 && dryBulb < 50) ppsat = 2.3675;
  else if (dryBulb >= 50 && dryBulb < 60) ppsat = 4.216;
  else if (dryBulb >= 60 && dryBulb < 70) ppsat = 7.044;
  else if (dryBulb >= 70 && dryBulb < 80) ppsat = 11.43;
  else if (dryBulb >= 80 && dryBulb < 90) ppsat = 17.38;
  else if (dryBulb >= 90 && dryBulb < 100) ppsat = 25.03;
  else if (dryBulb >= 100 && dryBulb < 110) ppsat = 34.47;
  else ppsat = 0;

  const parcialPressure = relativeHumidity * ppsat;

  const absoluteHumidity =
    0.622 * (parcialPressure / (airPressure / 1000 - parcialPressure));

  return { temperature: dryBulb, humidity: absoluteHumidity };
};

export const dzavra = (temperature, humidity, altitude) => {
  let relHum = humidity / 100;
  const airPressure = Math.round(
    constants.PressureAtSeaLevel *
      Math.exp(
        (-constants.GravityAcceleration * altitude * constants.MolarMass) /
          (constants.SeaLevelTemperature * constants.UniversalGas)
      ),
    2
    //MidpointRounding.AwayFromZero
  );
  //temp -50 do
  let pd;
  if (temperature < 0)
    pd = Math.exp((1738.4 + 28.74 * temperature) / (271 + temperature));
  else if (temperature <= 100)
    pd = Math.exp((1500.3 + 23.5 * temperature) / (234 + temperature));
  else pd = 0;

  let x = ((0.6222 * relHum * pd) / (airPressure - relHum * pd)) * 1000;

  return { temperature, humidity: x };
};
